import React  from 'react';
function MoneyZakatTable({ result }) {
  return (
    <table >
      <thead>
        <tr>
          <th >Status</th>
          <th >Results</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Zakat Obligation</td>
          <td>{result.zakatDuty === 'yes' ? 'Zakat is obligatory for you' : 'Zakat is not obligatory for you'}</td>
        </tr>
        <tr>
          <td>Zakat Wealth Threshold</td>
          <td>{result.threshold} </td>
        </tr>
        <tr>
          <td>Amount of Zakat to be Paid (from wealth)</td>
          <td>{result.zakat} </td>
        </tr>
      </tbody>
    </table>
  );
}
export default MoneyZakatTable;
